export default function WavyDivider({ fill = "#FFF8EC", flip = false, className = "" }) {
    return (
        <div aria-hidden="true" className={`${flip ? "rotate-180" : ""} ${className}`}>
            <svg viewBox="0 0 1440 100" preserveAspectRatio="none" className="block w-full h-[46px] md:h-[72px]">
                <path
                    d="M0,52 C150,86 330,10 540,34 C750,58 890,90 1090,62 C1250,40 1360,48 1440,64 L1440,100 L0,100 Z"
                    fill={fill}
                />
            </svg>
        </div>
    );
}
